//@ts-nocheck
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import Dropdown, {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "../../../components/bootstrap/Dropdown";
import Button from "../../../components/bootstrap/Button";
import LoaderWrapper from "../../../layout/Wrapper/LoaderWrapper";
import Card, {
  CardBody,
  CardHeader,
} from "../../../components/bootstrap/Card";

import { DownloadFile } from "../../../shared/utils";
import Modal, {
  ModalBody,
  ModalHeader,
  ModalTitle,
} from "../../../components/bootstrap/Modal";

import pdfServiceStore from "../../../user/mobx/pdfState";
import { toTitleCase } from "../../../helpers/helpers";
import PaginationButtons from "../../../components/PaginationButtons";
import moment from "moment";
import SearchBar from "../../../components/SearchBar";
import ascendingIcon from "../../../sorting/ascending-sorting.png"; // Import ascending icon
import descendingIcon from "../../../sorting/descending-sorting.png"; // Import descending icon

const EVENT_STATUS = {
  pending: "warning",
  complete: "success",
  failed: "danger",
};

// Remaining code here...

interface UserHistoryData {
  id: number;
  ip: string;
  sessionId: string;
  pdfPath: string | null;
  userId: number;
  targetUrl: string;
  createdAt: string;
  updatedAt: string;
  deleted: boolean;
  source: string;
  status: string;
}
function truncateText(text, maxLength) {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
}

const UserPdfHistory: React.FC = ({ startDate, endDate }) => {
  const [UserpdfHistory, setUserPdfHistory] = useState<UserHistoryData[]>([]);
  const [isLoading, setLoading] = useState(true);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewPath, setPreviewPath] = useState("");

  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc"); // New state for sorting order
  const [sortField, setSortField] = useState<string>("updatedAt"); // New state for sorting field

  const [filteredData, setFilteredData] = useState<any[]>([]); // New state for filtered data

  const openPreviewModal = (item) => {
    setPreviewPath(item.pdfPath ?? "");
    setPreviewModalOpen(true);
  };

  const closePreviewModal = () => {
    setPreviewPath("");
    setPreviewModalOpen(false);
  };

  const [searchQuery, setSearchQuery] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let dates = {};
      if (startDate && endDate) {
        dates["startDate"] = moment(startDate).format("YYYY-MM-DD");
        dates["endDate"] = moment(endDate).format("YYYY-MM-DD");
      }
      const d = await pdfServiceStore.userPdfHistory(
        {
          per_page: perPage, // Use the perPage state for dynamic pagination
          page: currentPage, // Use the currentPage state for pagination
          search: searchQuery, // Use the searchQuery state for searching
          orderBy: sortOrder, // Use the sortOrder state for sorting
          orderByField: sortField, // New parameter for sorting field
        },
        dates
      );
      console.log("Fetched Data:", d); // Log the fetched data
      const { data, total_records } = d;
      setTotalItems(total_records);
      setFilteredData(d?.data || []); // Initialize filtered data
      setUserPdfHistory(data || []);
      setLoading(false);
    };
    fetchData();
  }, [currentPage, perPage, searchQuery, sortOrder, sortField, startDate, endDate]);

  // const filteredData = UserpdfHistory.filter(item => {
  //   const searchTerms = searchQuery.toLowerCase().trim();
  //   if (!searchTerms) return true;

  //   return (
  //     item.targetUrl.toLowerCase().includes(searchTerms) ||
  //     toTitleCase(item.source).toLowerCase().includes(searchTerms) ||
  //     toTitleCase(item.status).toLowerCase().includes(searchTerms)
  //   );
  // });

  // const [searchQuery, setSearchQuery] = useState<string>("");

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const searchTerms = query.toLowerCase().trim();
    const results = UserpdfHistory.filter((item) => {
      return (
        item.targetUrl.toLowerCase().includes(searchTerms) ||
        item.source.toLowerCase().includes(searchTerms) ||
        item.status.toLowerCase().includes(searchTerms) ||
        item.updatedAt.toLowerCase().includes(searchTerms) ||
        (item.type === "current_page" ? "single" : "multiple")
          .toLowerCase()
          .includes(searchTerms)
      );
    });
    setFilteredData(results);
    setCurrentPage(1); // Reset to the first page on search
  };

  const toggleSortOrder = (field: string) => {
    if (sortField === field) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("desc"); // Reset to ascending when changing field
    }
  };

  const sortedData = filteredData.sort((a, b) => {
    const comparison = a[sortField]?.localeCompare(b[sortField]);
    return sortOrder === "asc" ? comparison : -comparison; // Sort based on order
  });

  // const paginatedData = sortedData.slice(
  //   (currentPage - 1) * perPage,
  //   currentPage * perPage
  // ); // Get current page data

  return (
    <>
      <Modal
        isOpen={previewModalOpen}
        onClose={closePreviewModal}
        title="Preview PDF"
        setIsOpen={setPreviewModalOpen}
        size="xl"
        buttonText="Close PDF"
      >
        <ModalHeader setIsOpen={setPreviewModalOpen}>
          <ModalTitle Id="preview_pdf">Preview</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <iframe
            title="PDF Preview"
            src={previewPath}
            width="100%"
            height="500px"
          />
        </ModalBody>
      </Modal>
      <div className="row">
        <div className="col-12 mt-3">
          <Card>
            <CardHeader borderSize={1}>
              <div className="search-wrap">
                <span className="fw-bold">PDF HISTORY</span>
                <SearchBar
                  fetchData={() => {}}
                  placeholder="Search pdf history..."
                  onSearch={handleSearch}
                />
              </div>
              {/* Export button can be added here if needed */}
            </CardHeader>
            <LoaderWrapper isLoading={isLoading} data={UserpdfHistory}>
              <CardBody
                className="table-responsive"
                style={{ overflow: "auto" }}
              >
                <table className="table table-modern dashboard-table">
                  <thead>
                    <tr>
                      {/* <th role="col">Target URL</th>
                      <th role="col">Page</th>
                      <th role="col">Source</th> */}

                      <th onClick={() => toggleSortOrder("targetUrl")}>
                        <div style={{ display: "flex", alignItems: "center",cursor:"pointer" }}>
                          Target url
                          {sortField === "targetUrl" &&
                            (sortOrder === "asc" ? (
                              <img
                                src={ascendingIcon}
                                alt="Ascending"
                                style={{
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                            ) : (
                              <img
                                src={descendingIcon}
                                alt="Descending"
                                style={{
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                            ))}
                        </div>
                      </th>
                      <th onClick={() => toggleSortOrder("type")}>
                        <div style={{ display: "flex", alignItems: "center",cursor:"pointer" }}>
                          Page
                          {sortField === "type" &&
                            (sortOrder === "asc" ? (
                              <img
                                src={ascendingIcon}
                                alt="Ascending"
                                style={{
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                            ) : (
                              <img
                                src={descendingIcon}
                                alt="Descending"
                                style={{
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                            ))}
                        </div>
                      </th>
                      <th onClick={() => toggleSortOrder("source")}>
                        <div style={{ display: "flex", alignItems: "center",cursor:"pointer" }}>
                          Source
                          {sortField === "source" &&
                            (sortOrder === "asc" ? (
                              <img
                                src={ascendingIcon}
                                alt="Ascending"
                                style={{
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                            ) : (
                              <img
                                src={descendingIcon}
                                alt="Descending"
                                style={{
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                            ))}
                        </div>
                      </th>
                      <th>Status</th>
                      <th onClick={() => toggleSortOrder("updatedAt")}>
                        <div style={{ display: "flex", alignItems: "center",cursor:"pointer" }}>
                          Completed Date
                          {sortField === "updatedAt" &&
                            (sortOrder === "asc" ? (
                              <img
                                src={ascendingIcon}
                                alt="Ascending"
                                style={{
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                            ) : (
                              <img
                                src={descendingIcon}
                                alt="Descending"
                                style={{
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                  width: "16px",
                                  height: "16px",
                                }}
                              />
                            ))}
                        </div>
                      </th>

                      {/* <th>PDF Path</th> */}

                      {/* <th role="col">Completed Date</th> */}
                      <th className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData.length > 0 ? (
                      sortedData.map((item) => (
                        <tr key={item.id}>
                          <td>{truncateText(item.targetUrl, 40)}</td>
                          <td>
                            {" "}
                            {item.type === "current_page"
                              ? "Single"
                              : "Multiple"}{" "}
                          </td>
                          <td>{toTitleCase(item.source)}</td>
                          {/* <td>{item.pdfPath ? item.pdfPath : 'N/A'}</td> */}

                          <td>
                            <Button
                              isLink
                              isDisable={true}
                              color={EVENT_STATUS[item.status] ?? "warning"}
                              icon="Circle"
                              className="text-nowrap"
                            >
                              {toTitleCase(
                                item.status === "complete"
                                  ? "Completed"
                                  : item.status
                              )}
                            </Button>
                          </td>
                          <td>
                            {item.status === "complete" ? (
                              dayjs(item.updatedAt).format("MM-DD-YYYY hh:mm A")
                            ) : (
                              <>--</>
                            )}
                          </td>
                          <td className="text-center">
                            {item.status === "complete" && item.pdfPath && (
                              <Dropdown>
                                <DropdownToggle hasIcon={false}>
                                  <Button
                                    icon="MoreHoriz"
                                    aria-label="More options"
                                  />
                                </DropdownToggle>
                                <DropdownMenu isAlignmentEnd>
                                  <DropdownItem>
                                    <Button
                                      onClick={() => openPreviewModal(item)}
                                      icon="Preview"
                                    >
                                      Preview
                                    </Button>
                                  </DropdownItem>
                                  <DropdownItem>
                                    <Button
                                      onClick={() =>
                                        DownloadFile(
                                          item.pdfPath,
                                          item.sessionId
                                        )
                                      }
                                      icon="Download"
                                    >
                                      Download
                                    </Button>
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </CardBody>
              <PaginationButtons
                data={filteredData}
                label="items"
                setCurrentPage={setCurrentPage}
                totalItems={totalItems}
                setPerPage={setPerPage}
                currentPage={currentPage}
              />
            </LoaderWrapper>
          </Card>
        </div>
      </div>
    </>
    // <PageWrapper title="PDF History">
    //     <Page container='fluid'>
    //         <Modal
    //             isOpen={previewModalOpen}
    //             onClose={closePreviewModal}
    //             title="Preview PDF"
    //             setIsOpen={setPreviewModalOpen}
    //             size="xl"
    //             buttonText="Close PDF">
    //             <ModalHeader setIsOpen={setPreviewModalOpen}>
    //                 <ModalTitle Id="preview_pdf">Preview</ModalTitle>
    //             </ModalHeader>
    //             <ModalBody>
    //                 <iframe title="PDF Preview" src={previewPath} width="100%" height="500px" />
    //             </ModalBody>
    //         </Modal>
    //         <div className='row'>
    //             <div className='col-12'>
    //                 <div className='display-6 fw-bold py-2'>Pdf History</div>
    //             </div>
    //             <div className='col-12'>
    //                 <Card>
    //                     <CardHeader borderSize={1}>
    //                         <CardLabel iconColor='info'>
    //                             <CardTitle tag='div' className='h5'>
    //                                 PDF History
    //                             </CardTitle>
    //                         </CardLabel>
    //                         {/* Export button can be added here if needed */}
    //                     </CardHeader>
    //                     <LoaderWrapper isLoading={isLoading} data={UserpdfHistory}>
    //                         <CardBody className='table-responsive'>
    //                             <table className='table table-modern'>
    //                                 <thead>
    //                                     <tr  >
    //                                         <th>Target URL</th>
    //                                         <th>Source</th>
    //                                         {/* <th>PDF Path</th> */}
    //                                         <th>Status</th>
    //                                         <th>Completed Date</th>
    //                                         <th className='text-center'>Action</th>
    //                                     </tr>
    //                                 </thead>
    //                                 <tbody>
    //                                     {UserpdfHistory?.map((item) => (
    //                                         <tr key={item.id}>
    //                                             <td>{item.targetUrl}</td>
    //                                             <td>{toTitleCase(item.source)}</td>
    //                                             {/* <td>{item.pdfPath ? item.pdfPath : 'N/A'}</td> */}

    //                                             <td>{toTitleCase(item.status === "complete" ? "Completed" : item.status)}</td>
    //                                             <td>{item.status === "complete" ? dayjs(item.updatedAt).format('MM-DD-YYYY') : <>--</>}</td>
    //                                             <td className='text-center'>

    //                                                 {item.status === "complete" && item.pdfPath && (
    //                                                     <Dropdown>
    //                                                         <DropdownToggle hasIcon={false}>
    //                                                             <Button
    //                                                                 icon='MoreHoriz'
    //                                                                 aria-label='More options'
    //                                                             />
    //                                                         </DropdownToggle>
    //                                                         <DropdownMenu isAlignmentEnd>

    //                                                             <DropdownItem>
    //                                                                 <Button onClick={() => openPreviewModal(item)} icon='Preview'>
    //                                                                     Preview
    //                                                                 </Button>
    //                                                             </DropdownItem>
    //                                                             <DropdownItem>
    //                                                                 <Button onClick={() => DownloadFile(item.pdfPath, item.sessionId)} icon='Download'>
    //                                                                     Download
    //                                                                 </Button>
    //                                                             </DropdownItem>
    //                                                         </DropdownMenu>
    //                                                     </Dropdown>

    //                                                 )}
    //                                             </td>
    //                                         </tr>
    //                                     ))}
    //                                 </tbody>
    //                             </table>
    //                         </CardBody>
    //                     </LoaderWrapper>
    //                 </Card>
    //             </div>
    //         </div>
    //     </Page>
    // </PageWrapper >
  );
};

export default UserPdfHistory;
